import * as Connector from 'shared/connectors/startConnector';
import { START } from 'store/types';

const init = () => ({
  type: START.GET_NEWS_INIT,
});

export const success = data => ({
  type: START.GET_NEWS_SUCCESS,
  payload: {
    data,
  },
});

const failure = () => ({
  type: START.GET_START_FAILURE,
});

const getNews = () => async dispatch => {
  dispatch(init());
  try {
    const { data } = await Connector.getNews();
    dispatch(success(data));
  } catch (err) {
    dispatch(failure());
  }
};

export default getNews;
